var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('section',{staticClass:"margin-top-2-rem margin-left-2-rem margin-right-2-rem"},[_c('progress',{staticClass:"progress is-large is-info",attrs:{"max":"100"}},[_vm._v(" Logging out ")])])])
}]

export { render, staticRenderFns }